export default "__VITE_ASSET__227aed0c__"